import * as Yup from 'yup';

const loginSchema = () =>
  Yup.object({
    email: Yup.string().email().required(),
    password: Yup.string().required(),
    rememberMe: Yup.boolean(),
  });

export type LoginSchemaType = Yup.InferType<ReturnType<typeof loginSchema>>;

export default loginSchema;
